import { type ComplianceObjectType, type RiskRating } from "~/graphql/supergraphTypes";
import { CompliancePaymentAccountType } from "../../../Profiles/BankAccountCard/EditBankAccountAction/types";
import { PositionData } from "../types";

export const transformToCompliancePaymentAccount = (
  data: PositionData,
): CompliancePaymentAccountType => {
  return {
    id: data.linkedProfileId ?? 0,
    profileId: data.linkedProfileId ?? 0,
    profile: data.linkedProfile
      ? {
          id: data.linkedProfileId ?? 0,
          firstName: data.linkedProfile.firstName ?? null,
          middleName: null,
          lastName: data.linkedProfile.lastName ?? null,
          legalName: data.linkedProfile.legalName ?? null,
          complianceObjectType:
            (data.linkedOnboardingCase?.investingProfile
              ?.complianceObjectType as ComplianceObjectType) ?? "UNKNOWN",
          accountType: null,
          paymentAccounts: [],
          screeningRecord: null,
          parentRelationships: [],
        }
      : null,
    providerName: data.currentBankName ?? "",
    bankCountry:
      data.currentBankName || data.countryAlpha2code
        ? {
            name: data.currentBankName || "--",
            alpha2code: data.countryAlpha2code ?? "",
          }
        : null,
    payeeName: data.paymentAccountOverrides?.payeeName ?? null,
    mismatchReason: data.paymentAccountOverrides?.mismatchReason ?? null,
    riskRating: {
      overriddenRating:
        (data.paymentAccountOverrides?.overriddenRiskRating as RiskRating) ?? null,
    },
  };
};
